import { useDeleteReports } from "PFCore/hooks/queries/bookings/manage_reports/use_reports";
import TrashIcon from "PFIcons/trash.svg";
import React, { useState } from "react";

import css from "../../manage_reports.module.scss";
import { ConfirmDeleteModal } from "./confirm_delete_modal";

type DeleteActionProps = {
  reportId: number;
  reportName: string;
};

export const DeleteButton = ({ reportId, reportName }: DeleteActionProps): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { mutate } = useDeleteReports(reportId);

  return (
    <>
      <button className={css.deleteAction} onClick={() => setIsModalVisible(true)}>
        <TrashIcon width={14} height={14} />
      </button>
      {isModalVisible && (
        <ConfirmDeleteModal
          reportName={reportName}
          onClose={() => setIsModalVisible(false)}
          onDelete={() => mutate(reportId)}
        />
      )}
    </>
  );
};
